import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TechnicianService } from '../../../../../services/technician.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { Time } from '@angular/common';
import moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit {
  @Input() event: any;
  @Input() user: any;
  @Input() leaveEvent: any;
  @Input() eventPopup: OverlayPanel;
  @Output() refresh = new EventEmitter();

  public newEvent: boolean = true;
  public minDate: Date = new Date();
  public startTime: Date = new Date(0, 0, 0, 8, 0, 0);
  public endTime: Date = new Date(0, 0, 0, 9, 0, 0);
  public busy: boolean = false;
  public countryData: any = {};

  constructor(
    public technicianService: TechnicianService,
    private helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    if (this.event && this.event.ID) {
      this.newEvent = false;
      this.event.StartTime = new Date(this.event.StartTime);
      this.event.EndTime = new Date(this.event.EndTime);
      this.startTime = this.event.StartTime;
      this.endTime = this.event.EndTime;
    } else {
      this.event = {
        Description: '',
        StartTime: new Date(),
        EndTime: new Date(),
        IsRecurringEvent: false,
        RecurIntervalDays: 0,
        RecurringCount: 0,
      };
    }
  }

  valid() {
    return (
      this.event.Description &&
      this.event.Description.length > 0 &&
      this.event.StartTime &&
      (this.event.IsRecurringEvent
        ? this.event.RecurIntervalDays > 0 && this.event.RecurringCount > 0
        : true)
    );
  }

  saveEvent() {
    let tzoffset = new Date().getTimezoneOffset() * 60000;
    this.event.StartTime = new Date(
      this.event.StartTime.getFullYear(),
      this.event.StartTime.getMonth(),
      this.event.StartTime.getDate(),
      this.startTime.getHours(),
      this.startTime.getMinutes(),
      0,
    );
    this.event.EndTime = new Date(
      this.event.StartTime.getFullYear(),
      this.event.StartTime.getMonth(),
      this.event.StartTime.getDate(),
      this.endTime.getHours(),
      this.endTime.getMinutes(),
      0,
    );

    if (!this.event.ID) {
      this.busy = true;
      this.technicianService
        .createCalendarEvent(
          this.user.TechnicianID ? this.user.TechnicianID : this.user.ID,
          this.event.Description,
          moment(this.event.StartTime - tzoffset).toISOString(false),
          moment(this.event.EndTime - tzoffset).toISOString(false),
          this.event.IsRecurringEvent,
          this.event.RecurringCount,
          this.event.RecurIntervalDays,
        )
        .subscribe((event) => {
          this.refresh.emit();
          this.eventPopup.hide();
          this.busy = false;
        });
    } else {
      this.busy = true;
      this.technicianService
        .updateCalendarEvent(
          this.event.ID,
          this.user.TechnicianID ? this.user.TechnicianID : this.user.ID,
          this.event.Description,
          moment(this.event.StartTime - tzoffset).toISOString(false),
          moment(this.event.EndTime - tzoffset).toISOString(false),
          this.event.IsRecurringEvent,
          this.event.RecurringCount,
          this.event.RecurIntervalDays,
        )
        .subscribe((event) => {
          this.refresh.emit();
          this.eventPopup.hide();
          this.busy = false;
        });
    }
  }
}
